import useHasPermission from './useHasPermission';

function useAccessValidation({ pagePath }: { pagePath: string }): boolean | undefined {
  const webArtifact = `web:${pagePath}`;
  const hasPermission = useHasPermission(webArtifact);

  // If user has no roles loaded yet, return undefined (loading state)
  // The permission check happens client-side now via the profile roles
  return hasPermission || undefined;
}

export default useAccessValidation;
